<cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-grundstueckbeschreibung">
  <ng-container title>
    <h2 class="mb-0">{{ "grundstueck.rubrik.Grundstueckbeschreibung" | translate }}</h2>
  </ng-container>

  @if (gsId.id) {
    <cap-grundstueck-beschreibung
      [gsId]="gsId"
      [hasRight]="grundstueckEntry?.permissions?.beschreibung && grundstueckEntry?.permissions?.beschreibungErsterfassungUebergeben">
    </cap-grundstueck-beschreibung>
  }
</cap-rubrik>

<cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-grundstueck-anmerkungen">
  <ng-container title>
    <h2 class="mb-0">{{ "grundstueck.rubrik.Anmerkungen" | translate }}</h2>
  </ng-container>
  @if (showLableNichtOeffentlicheAnmerkungen && grundstueckEntry?.permissions?.anmerkungen) {
    <div class="text-nowrap mt-1"><i class="fas fa-info-circle"></i> {{ "NurOeffentlicheAnmerkungenWerdenAngezeigt" | translate }}</div>
  }
  <cap-standardrecht-table
    [hasRight]="grundstueckEntry?.permissions?.anmerkungen && anmerkungErsterfassungUebergeben"
    [listLoader]="anmerkungListLoader">
  </cap-standardrecht-table>
</cap-rubrik>

<cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-grundstueck-eigentum">
  <ng-container title>
    <h2 class="mb-0">{{ "grundstueck.rubrik.Eigentum" | translate }}</h2>
  </ng-container>
  <cap-eigentum-table
    [hasRight]="grundstueckEntry?.permissions?.eigentum && eigentumErsterfassungUebergeben"
    [listLoader]="eigentumLoader"
    [navigateToGrundstueck]="navTargetGrundstuecke"
    [showAdressen]="false"
    [showEigentumHeaderWithText]="false">
  </cap-eigentum-table>
</cap-rubrik>

@if (isErweiterungNeskoabAktiv) {
  <cap-rubrik [isClosable]="false" [isOpen]="true" class="externe-daten" id="rubrik-grundstueck-neskoab">
    <ng-container title>
      <h2 class="mb-0">{{ "neskoab.AmtlicheBewertung" | translate }}</h2>
    </ng-container>
    <cap-neskoab-rubrik-uebersicht [gsId]="gsId"></cap-neskoab-rubrik-uebersicht>
  </cap-rubrik>
}

@if (isErweiterungOerebAktiv) {
  <cap-rubrik [isClosable]="false" [isOpen]="true" class="externe-daten" id="rubrik-grundstueck-oereb">
    <ng-container title>
      <h2 class="mb-0">{{ "grundstueck.rubrik.Oereb" | translate }}</h2>
    </ng-container>
    <cap-oereb-uebersicht></cap-oereb-uebersicht>
  </cap-rubrik>
}
